import React from 'react';

function UsersList({ users, currentUser }) {
  return (
    <div className="card-box container-large">
      <div className="container-header">
        <h3>👥 Registered Friends & Users</h3>
        <span className="count-badge">{users.length} members</span>
      </div>
      <div className="users-card-grid">
        {users.map((u) => {
          const isMe = u.id === currentUser.id;
          return (
            <div key={u.id} className={`user-detail-card ${isMe ? 'highlighted' : ''}`}>
              <div className="user-detail-avatar">
                {u.name.substring(0, 2).toUpperCase()}
              </div>
              <div className="user-detail-info">
                <h4>{u.name} {isMe && <span className="me-badge">You</span>}</h4>
                <p>{u.email}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default UsersList;
